<template lang="pug">
p.store-managed-line
  span {{ text }}
  a(v-if="link" :href="link.href" target="_blank" rel="noopener noreferrer") {{ link.label }}
</template>

<script lang="ts" setup>
import { storeManagedText, storeSubscriptionsLink, type StoreManagement } from '@/utils/storeManaged'

const props = defineProps<{ managed: StoreManagement }>()
const { t, locale } = useI18n()
const text = computed(() => storeManagedText(t, props.managed, locale.value))
const link = computed(() => storeSubscriptionsLink(t, props.managed.store))
</script>

<style scoped>
.store-managed-line {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.25rem 0.75rem;
  margin: 0;
}

.store-managed-line a {
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 4px;
}
</style>
